module.exports = __webpack_public_path__ + "img/bg-footer-sep.2593c5ee.png";